module.exports = __webpack_public_path__ + "img/emp-peek-mobile.67ce4f55.jpg";